// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M2LUJqZpwgAOzKGo7lNd{flex-direction:column;flex-grow:1;width:760px;margin:0 auto;display:flex}.AZwdHweIH90ltg6uyzgz{flex-direction:column;gap:4px;display:flex}.VS0SRnAQuFgkLdT6pIiW{text-align:center;margin-bottom:4px}.m3Mq7RvOOmEV_12ZBQTL{height:100%;padding:32px 11px 0 15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `M2LUJqZpwgAOzKGo7lNd`,
	"inboxesDetailsHeader": `AZwdHweIH90ltg6uyzgz`,
	"createInboxText": `VS0SRnAQuFgkLdT6pIiW`,
	"table": `m3Mq7RvOOmEV_12ZBQTL`
};
export default ___CSS_LOADER_EXPORT___;
